/* eslint-disable @typescript-eslint/no-use-before-define */
import { useEffect, useRef } from "react";

import { typedQueryClient } from "hooks";
import { AuthKeys } from "modules/Auth/queryKeys";
import ApiInstance from "util/Api";

export const SessionManager = () => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const authInfo = typedQueryClient.getQueryData(AuthKeys.tokenStatus);

  const handleTokenExpiration = () => {
    const timeRemaining = ApiInstance.sessionExpirationTime - Date.now();
    if (timeRemaining <= 0) {
      typedQueryClient.setQueryData(AuthKeys.tokenStatus, { isExpired: true });
    } else {
      setTokenExpirationTimeout();
    }
  };

  const setTokenExpirationTimeout = () => {
    const timeRemaining = ApiInstance.sessionExpirationTime - Date.now();
    timeoutRef.current = setTimeout(handleTokenExpiration, timeRemaining);
  };

  const handleVisibilityChange = () => {
    if (document.hidden) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    } else {
      setTokenExpirationTimeout();
    }
  };

  useEffect(() => {
    setTokenExpirationTimeout();
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [authInfo]);

  return null;
};
